(function () {
class ContactRoutingForm {
  constructor(form) {
    this.form = form;
    this.conditionals = [...form.querySelectorAll('[data-conditional]')];
    this.radios = [...form.querySelectorAll('[data-route]')];
    this.radios.forEach((radio) => radio.addEventListener('change', () => this.update()));
    this.update();
  }

  update() {
    const selected = this.radios.find((radio) => radio.checked)?.value;
    this.conditionals.forEach((group) => {
      const visible = group.dataset.conditional.split(' ').includes(selected);
      group.hidden = !visible;
      group.querySelectorAll('input, select, textarea').forEach((field) => {
        field.disabled = !visible;
      });
    });
  }
}

function initContactRoutingForms(root = document) {
  root.querySelectorAll('[data-contact-routing]').forEach((form) => {
    if (form.dataset.routingReady) return;
    form.dataset.routingReady = 'true';
    new ContactRoutingForm(form);
  });
}

class ContactFAQ {
  constructor(section) {
    this.section = section;
    this.tabs = [...section.querySelectorAll('[role="tab"][data-faq-category]')];
    this.panels = [...section.querySelectorAll('[role="tabpanel"][data-faq-panel]')];
    this.currentRoute = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true')?.dataset.formRoute || 'produit';

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(tab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    section.querySelectorAll('.ls-contact-faq__accordion').forEach((accordion) => {
      accordion.querySelectorAll('details').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          accordion.querySelectorAll('details[open]').forEach((other) => {
            if (other !== details) other.open = false;
          });
        });
      });
    });

    section.querySelector('[data-contact-after-faq]')?.addEventListener('click', () => this.prefillForm());
  }

  select(tab, focus = false) {
    this.currentRoute = tab.dataset.formRoute;
    this.tabs.forEach((item) => {
      const selected = item === tab;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.faqPanel !== tab.dataset.faqCategory;
    });
    if (focus) tab.focus();
  }

  onKeydown(event, index) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    let nextIndex = index;
    if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    this.select(this.tabs[nextIndex], true);
  }

  prefillForm() {
    const route = document.querySelector(`[data-contact-routing] [data-route][value="${this.currentRoute}"]`);
    if (!route) return;
    route.checked = true;
    route.dispatchEvent(new Event('change', { bubbles: true }));
  }

  showBlock(block) {
    const panel = block.closest('[data-faq-panel]');
    const details = block.closest('details');
    if (!panel) return;
    const tab = this.tabs.find((item) => item.dataset.faqCategory === panel.dataset.faqPanel);
    if (tab) this.select(tab);
    if (details) details.open = true;
  }
}

function initContactFAQs(root = document) {
  root.querySelectorAll('[data-contact-faq]').forEach((section) => {
    if (section.dataset.faqReady) return;
    section.dataset.faqReady = 'true';
    section.contactFAQ = new ContactFAQ(section);
  });
}

initContactRoutingForms();
initContactFAQs();
document.addEventListener('shopify:section:load', (event) => {
  initContactRoutingForms(event.target);
  initContactFAQs(event.target);
});
document.addEventListener('shopify:block:select', (event) => {
  const section = event.target.closest('[data-contact-faq]');
  if (section?.contactFAQ) section.contactFAQ.showBlock(event.target);
});
})();
